import axios from 'axios';

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
// Determinar la URL base según el entorno
const getApiBaseUrl = () => {
  // Si hay una variable de entorno específica para producción, usarla
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Por defecto, usar la URL local durante el desarrollo
  return 'http://localhost:3000/api';
};

// Usar la URL relativa '/api' cuando el hostname no sea localhost (entorno de producción)
const isProduction = typeof window !== 'undefined' && window.location && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
const API_URL = isProduction ? '/api' : getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authService = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (data) => api.post('/auth/registro', data),
  getProfile: () => api.get('/auth/perfil'),
  updateProfile: (data) => api.put('/auth/perfil', data)
};

// Clientes
export const clienteService = {
  getAll: (params) => api.get('/clientes', { params }),
  getById: (id) => api.get(`/clientes/${id}`),
  create: (data) => api.post('/clientes', data),
  update: (id, data) => api.put(`/clientes/${id}`, data),
  delete: (id) => api.delete(`/clientes/${id}`)
};

// Cotizaciones
export const cotizacionService = {
  getAll: (params) => api.get('/cotizaciones', { params }),
  getById: (id) => api.get(`/cotizaciones/${id}`),
  create: (data) => api.post('/cotizaciones', data),
  update: (id, data) => api.put(`/cotizaciones/${id}`, data),
  enviarEmail: (id) => api.post(`/cotizaciones/${id}/enviar`),
  cambiarEstado: (id, estado) => api.patch(`/cotizaciones/${id}/estado`, { estado }),
  delete: (id) => api.delete(`/cotizaciones/${id}`),
  agregarImagen: (data) => api.post('/cotizaciones/imagenes', data),
  eliminarImagen: (imagen_id) => api.delete(`/cotizaciones/imagenes/${imagen_id}`)
};

// Proyectos
export const proyectoService = {
  getAll: (params) => api.get('/proyectos', { params }),
  getById: (id) => api.get(`/proyectos/${id}`),
  create: (data) => api.post('/proyectos', data),
  createFromCotizacion: (data) => api.post('/proyectos/desde-cotizacion', data),
  update: (id, data) => api.put(`/proyectos/${id}`, data),
  aprobar: (id) => api.patch(`/proyectos/${id}/aprobar`),
  finalizar: (id) => api.patch(`/proyectos/${id}/finalizar`),
  delete: (id) => api.delete(`/proyectos/${id}`),
  enviarEmail: (id) => api.post(`/proyectos/${id}/enviar`),
  registrarAvance: (data) => api.post('/proyectos/avances', data),
  validarAvance: (avance_id) => api.patch(`/proyectos/avances/${avance_id}/validar`),
  asignarTrabajador: (data) => api.post('/proyectos/asignar-trabajador', data),
  desasignarTrabajador: (asignacion_id) => api.delete(`/proyectos/asignaciones/${asignacion_id}`),
  asignarCapataz: (data) => api.post('/proyectos/asignar-capataz', data),
  desasignarCapataz: (data) => api.post('/proyectos/desasignar-capataz', data),
  agregarImagen: (data) => api.post('/proyectos/imagenes', data),
  eliminarImagen: (imagen_id) => api.delete(`/proyectos/imagenes/${imagen_id}`),
  agregarItem: (data) => api.post('/proyectos/items', data),
  eliminarItem: (item_id) => api.delete(`/proyectos/items/${item_id}`)
};

// Trabajadores
export const trabajadorService = {
  getAll: (params) => api.get('/trabajadores', { params }),
  getById: (id) => api.get(`/trabajadores/${id}`),
  create: (data) => api.post('/trabajadores', data),
  update: (id, data) => api.put(`/trabajadores/${id}`, data),
  delete: (id) => api.delete(`/trabajadores/${id}`)
};

// Servicios
export const servicioService = {
  getAll: (params) => api.get('/servicios', { params }),
  create: (data) => api.post('/servicios', data),
  update: (id, data) => api.put(`/servicios/${id}`, data),
  delete: (id) => api.delete(`/servicios/${id}`)
};

// Productos
export const productoService = {
  getAll: (params) => api.get('/productos', { params }),
  create: (data) => api.post('/productos', data),
  update: (id, data) => api.put(`/productos/${id}`, data),
  ajustarStock: (id, cantidad, tipo) => api.patch(`/productos/${id}/stock`, { cantidad, tipo }),
  delete: (id) => api.delete(`/productos/${id}`)
};

// Capataces
export const capatazService = {
  buscar: (codigo) => api.get(`/capataces/buscar/${codigo}`),
  invitar: (capataz_id) => api.post('/capataces/invitar', { capataz_id }),
  reenviarInvitacion: (capataz_id) => api.post(`/capataces/reenviar-invitacion/${capataz_id}`),
  getLista: () => api.get('/capataces/lista'),
  getInvitaciones: () => api.get('/capataces/invitaciones'),
  getAsociaciones: () => api.get('/capataces/asociaciones'),
  aceptarInvitacion: (contratista_id) => api.post('/capataces/aceptar-invitacion', { contratista_id }),
  rechazarInvitacion: (contratista_id) => api.post('/capataces/rechazar-invitacion', { contratista_id }),
  eliminar: (capataz_id) => api.delete(`/capataces/${capataz_id}`)
};

// Upload
export const uploadService = {
  subirImagen: (formData) => {
    return api.post('/upload/imagen', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  subirImagenes: (formData) => {
    return api.post('/upload/imagenes', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

// Especialidades
export const especialidadService = {
  getAll: (params) => api.get('/especialidades', { params }),
  create: (data) => api.post('/especialidades', data),
  update: (id, data) => api.put(`/especialidades/${id}`, data),
  delete: (id) => api.delete(`/especialidades/${id}`)
};

// Gastos
export const gastoService = {
  create: (data) => api.post('/gastos', data),
  getByProyecto: (proyecto_id) => api.get(`/gastos/proyecto/${proyecto_id}`),
  getResumen: (proyecto_id) => api.get(`/gastos/proyecto/${proyecto_id}/resumen`),
  getById: (id) => api.get(`/gastos/${id}`),
  update: (id, data) => api.put(`/gastos/${id}`, data),
  delete: (id) => api.delete(`/gastos/${id}`),
  agregarImagen: (data) => api.post('/gastos/imagenes', data),
  eliminarImagen: (imagen_id) => api.delete(`/gastos/imagenes/${imagen_id}`)
};

// Reportes
export const reporteService = {
  getGeneral: () => api.get('/reportes/general'),
  getProyecto: (proyecto_id) => api.get(`/reportes/proyecto/${proyecto_id}`)
};

// Admin
export const adminService = {
  getMetricas: () => api.get('/admin/metricas'),
  getUsuarios: () => api.get('/admin/usuarios'),
  getEstadisticasContratista: (id) => api.get(`/admin/usuarios/${id}/estadisticas`),
  activarLicencia: (data) => api.post('/admin/licencias/activar', data),
  desactivarLicencia: (data) => api.post('/admin/licencias/desactivar', data),
  getConfiguracion: (clave = null) => api.get(clave ? `/admin/configuracion/${clave}` : '/admin/configuracion'),
  updateConfiguracion: (data) => api.put('/admin/configuracion', data)
};

// Configuración (para usuarios autenticados)
export const configuracionService = {
  getUrlTiendaLicencias: () => api.get('/configuracion/tienda-licencias')
};

export default api;
